import { palette } from "../palette";
export const input = {
  backgroundColor: palette.white,
  borderColor: palette.gray.primary,
  borderRadius: "4px",
  color: palette.black,
  placeholder: {
    color: palette.gray.primary
  },
  focus: {
    borderColor: palette.action.lighter,
    boxShadow: `0 0 4px 0 ${palette.action.lighter}`
  },
  disabled: {
    backgroundColor: palette.gray.lightest,
    borderColor: palette.gray.lighter,
    color: palette.gray.primary,
    placeholder: {
      color: palette.gray.lighter
    }
  },
  error: {
    backgroundColor: palette.red.lightest,
    borderColor: palette.red.primary
  },
  select: {
    dropdown: {
      borderColor: palette.gray.primary,
      borderTopColor: palette.gray.lightest,
      backgroundColor: palette.white,
      divider: palette.gray.lightest
    },
    open: {
      borderBottomColor: palette.gray.lightest
    }
  }
};